import { makeTab, normalizeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { EDUCATION_OFFERS, LEARNING_TYPES } from '@sravni/ugc/lib/specialOffers/lists';
import type { Tab } from '@sravni/ugc/lib/specialOffers/types';

export const normalizeTabWithOldKursy = (tab): Tab => {
  if (tab === 'programming') return makeTab(EDUCATION_OFFERS.learning, LEARNING_TYPES.typeProgramming);

  return normalizeTab(tab);
};

export const normalizeTabsWithOldKursy = (tabs): Tab[] => tabs.map(normalizeTabWithOldKursy);
